export const addGtmClickTypeAttributes=gtmClickType=>{return gtmClickType?{'data-gtm-click-type':gtmClickType}:{};};